export const convertCourseType = (courseType: string): string => {
  const typeMap: Record<string, string> = {
    SINGLE: "one_day",
    MULTI: "multiple_sessions",
  };
  return typeMap[courseType] || "";
};
